import React, { useState ,useContext} from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../../context/ToastContext';
import { AuthContext } from '../../context/AuthContext';
import { User, Mail, Lock, Phone, CheckSquare, Square, ShieldCheck } from 'lucide-react';

export default function Register({ onSuccess }) {
  const [clientName, setClientName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [gender, setGender] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [checked, setChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  // States cho luồng OTP
  const [isOtpStep, setIsOtpStep] = useState(false);
  const [otpCode, setOtpCode] = useState("");
  const [verifying, setVerifying] = useState(false);

  // States lưu lỗi form đăng ký
  const [errClientName, setErrClientName] = useState("");
  const [errEmail, setErrEmail] = useState("");
  const [errPhone, setErrPhone] = useState("");
  const [errPassword, setErrPassword] = useState("");
  const [errConfirmPassword, setErrConfirmPassword] = useState("");
  const [errGender, setErrGender] = useState("");
  const [errDateOfBirth, setErrDateOfBirth] = useState("");
  const [errChecked, setErrChecked] = useState("");

  const { showToast } = useToast();
  const { login } = useContext(AuthContext);
  const EmailValidation = (emailStr) => {
    return String(emailStr)
      .toLowerCase()
      .match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i);
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    let isValid = true;

    if (!clientName.trim()) { setErrClientName("Vui lòng nhập tên của bạn"); isValid = false; } else { setErrClientName(""); }
    if (!email.trim()) { setErrEmail("Vui lòng nhập email"); isValid = false; } 
    else if (!EmailValidation(email)) { setErrEmail("Email không đúng định dạng"); isValid = false; } 
    else { setErrEmail(""); }

    const passRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!\%*?&]{8,}$/;
    if (!password) { setErrPassword("Vui lòng tạo mật khẩu"); isValid = false; } 
    else if (!passRegex.test(password)) { setErrPassword("Mật khẩu phải chứa ít nhất 8 ký tự, 1 chữ hoa, 1 thường, 1 số và 1 ký tự đặc biệt"); isValid = false; } 
    else { setErrPassword(""); }
    
    if (!confirmPassword) { 
      setErrConfirmPassword("Vui lòng xác nhận lại mật khẩu"); 
      isValid = false; 
    } else if (confirmPassword !== password) { 
      setErrConfirmPassword("Mật khẩu xác nhận không khớp"); 
      isValid = false; 
    } else { 
      setErrConfirmPassword(""); 
    }

    if (!gender) { setErrGender("Vui lòng chọn giới tính"); isValid = false; } else { setErrGender(""); }
    if (!phone.trim()) { setErrPhone("Vui lòng nhập số điện thoại"); isValid = false; } else { setErrPhone(""); }
    if (!dateOfBirth) { setErrDateOfBirth("Vui lòng chọn ngày sinh"); isValid = false; } else { setErrDateOfBirth(""); }
    if (!checked) { setErrChecked("Vui lòng đồng ý với Điều khoản dịch vụ"); isValid = false; } else { setErrChecked(""); }

    if (isValid) {
      setLoading(true);
      const userData = {
        fullName: clientName,
        email: email,
        password: password,
        gender: gender,
        phoneNumber: phone,
        dateOfBirth: dateOfBirth,
      };

      try {
        const response = await axios.post("https://japanichiba.duckdns.org/api/v1/auth/register", userData);
        if (response.status === 200 || response.status === 201) {
          showToast(`Đăng ký thành công! Hãy kiểm tra mã OTP gửi về ${email}`, "success");
          setIsOtpStep(true); 
        }
      } catch (error) {
        const message = error.response?.data?.message || "Email này đã tồn tại hoặc có lỗi xảy ra!";
        showToast(message, "error");
      } finally {
        setLoading(false);
      }
    }
  };
const handleVerifyOtp = async (e) => {
    e.preventDefault();
    try {
      setVerifying(true);
      // Gọi API xác thực OTP
      const response = await axios.post("https://japanichiba.duckdns.org/api/v1/auth/verify-otp", {
        email: email, // email lấy từ state lúc đăng ký
        otp: otpCode
      });

      const resBody = response.data;
      const userData = resBody.data || resBody;
      const token = resBody.accessToken || userData.accessToken;

      if (login) {
        login(userData, token);
      } else {
        if (token) localStorage.setItem("token", token);
        localStorage.setItem("user", JSON.stringify(userData));
      }

      showToast("Đăng ký và kích hoạt tài khoản thành công! 🎉", "success");

      if (onSuccess) {
        onSuccess(userData);
      }

      setTimeout(() => {
        navigate("/"); 
      }, 1000);

    } catch (error) {
      showToast(error.response?.data?.message || "Mã OTP không chính xác!", "error");
    }finally {
      setVerifying(false);
    }
  };
  const [countdown, setCountdown] = useState(120);

  React.useEffect(() => {
    let timer;
    if (isOtpStep && countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [isOtpStep, countdown]);

  const handleResendOtp = async() => {
    try {
      // Gọi API gửi lại OTP xuống Backend
      const response = await axios.post("https://japanichiba.duckdns.org/api/v1/auth/resend-otp", {
        email: email
      });

      if (response.data && response.data.success === false) {
        showToast(response.data.message || "Không thể gửi lại mã OTP!", "error");
        return;
      }

      setCountdown(120); // Reset lại bộ đếm 120 giây
      showToast("Đã gửi lại mã OTP mới vào Gmail của bạn! ✉️", "success");
    } catch (error) {
      console.error("Lỗi gửi lại OTP:", error);
      const errorMsg = error.response?.data?.message || "Không thể kết nối đến máy chủ để gửi lại OTP!";
      showToast(errorMsg, "error");
    }
  };

  if (isOtpStep) {
    return (
      <form onSubmit={handleVerifyOtp} className="space-y-4 py-4 text-center">
        <div className="w-12 h-12 bg-indigo-50 text-indigo-600 rounded-full flex items-center justify-center mx-auto mb-2">
          <ShieldCheck className="w-6 h-6" />
        </div>
        <h3 className="text-base font-bold text-slate-900">Xác Thực Địa Chỉ Gmail</h3>
        <p className="text-xs text-slate-500 max-w-xs mx-auto">
          Chúng tôi đã gửi mã xác thực 6 chữ số đến hộp thư <span className="font-bold text-slate-800">{email}</span>. Vui lòng kiểm tra và nhập bên dưới.
        </p>

        <div>
          <input
            type="text"
            maxLength="6"
            value={otpCode}
            onChange={(e) => setOtpCode(e.target.value)}
            placeholder="123456"
            className="w-48 text-center tracking-widest font-extrabold text-lg px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-600 transition"
          />
        </div>

        {/* THÊM HIỂN THỊ THỜI GIAN ĐẾM NGƯỢC */}
        <div className="text-xs font-semibold text-amber-600 bg-amber-50 py-1.5 px-3 rounded-lg inline-block my-1">
          {countdown > 0 ? `Mã OTP sẽ hết hạn sau: ${countdown} giây` : "⚠️ Mã OTP đã hết hạn!"}
        </div>

        <button
          type="submit"
          disabled={verifying}
          className="w-full py-2.5 bg-indigo-600 hover:bg-indigo-500 text-white font-bold rounded-xl shadow-lg shadow-indigo-600/30 transition text-xs"
        >
          {verifying ? "Đang xác thực..." : "Xác Nhận OTP"}
        </button>

        {/* ĐÃ SỬA: Khóa click gửi lại nếu đếm ngược lớn hơn 0 */}
        <p className="text-[11px] text-slate-400">
          Không nhận được mã?{" "}
          <button
            type="button"
            disabled={countdown > 0}
            onClick={handleResendOtp}
            className={`font-semibold underline ${countdown > 0 ? "text-slate-300 cursor-not-allowed" : "text-indigo-600 hover:text-indigo-500"}`}
          >
            Gửi lại
          </button>
        </p>
      </form>
    );
  }

  return (
    <form onSubmit={handleSignUp} className="space-y-3 max-h-[75vh] overflow-y-auto pr-1">
      <div>
        <label className="block text-[11px] font-bold text-slate-700 uppercase mb-1">Họ và tên</label>
        <div className="relative">
          <User className="absolute left-3 top-3 w-4 h-4 text-slate-400" />
          <input type="text" value={clientName} onChange={(e) => { setClientName(e.target.value); setErrClientName(""); }} placeholder="Nguyen Van A" className="w-full pl-9 pr-3 py-2 bg-slate-50 border border-slate-200 rounded-xl text-xs focus:outline-none focus:ring-2 focus:ring-indigo-600 transition" />
        </div>
        {errClientName && <p className="text-[11px] text-rose-500 mt-0.5">{errClientName}</p>}
      </div>

      <div>
        <label className="block text-[11px] font-bold text-slate-700 uppercase mb-1">Email</label>
        <div className="relative">
          <Mail className="absolute left-3 top-3 w-4 h-4 text-slate-400" />
          <input type="email" value={email} onChange={(e) => { setEmail(e.target.value); setErrEmail(""); }} placeholder="name@example.com" className="w-full pl-9 pr-3 py-2 bg-slate-50 border border-slate-200 rounded-xl text-xs focus:outline-none focus:ring-2 focus:ring-indigo-600 transition" />
        </div>
        {errEmail && <p className="text-[11px] text-rose-500 mt-0.5">{errEmail}</p>}
      </div>

      <div>
        <label className="block text-[11px] font-bold text-slate-700 uppercase mb-1">Mật khẩu</label>
        <div className="relative">
          <Lock className="absolute left-3 top-3 w-4 h-4 text-slate-400" />
          <input type="password" value={password} onChange={(e) => { setPassword(e.target.value); setErrPassword(""); }} placeholder="Ít nhất 8 ký tự, có chữ hoa, số, ký tự đặc biệt" className="w-full pl-9 pr-3 py-2 bg-slate-50 border border-slate-200 rounded-xl text-xs focus:outline-none focus:ring-2 focus:ring-indigo-600 transition" />
        </div>
        {errPassword && <p className="text-[11px] text-rose-500 mt-0.5">{errPassword}</p>}
      </div>
      <div>
        <label className="block text-[11px] font-bold text-slate-700 uppercase mb-1">Xác nhận mật khẩu</label>
        <div className="relative">
        <Lock className="absolute left-3 top-3 w-4 h-4 text-slate-400" />
        <input type="password" value={confirmPassword} onChange={(e) => { setConfirmPassword(e.target.value); setErrConfirmPassword(""); }} placeholder="Nhập lại mật khẩu" className="w-full pl-9 pr-3 py-2 bg-slate-50 border border-slate-200 rounded-xl text-xs focus:outline-none focus:ring-2 focus:ring-indigo-600 transition" />
        </div>
        {errConfirmPassword && <p className="text-[11px] text-rose-500 mt-0.5">{errConfirmPassword}</p>}
      </div>
      <div>
        <label className="block text-[11px] font-bold text-slate-700 uppercase mb-1">Số điện thoại</label>
        <div className="relative">
          <Phone className="absolute left-3 top-3 w-4 h-4 text-slate-400" />
          <input type="text" value={phone} onChange={(e) => { setPhone(e.target.value); setErrPhone(""); }} placeholder="0912345678" className="w-full pl-9 pr-3 py-2 bg-slate-50 border border-slate-200 rounded-xl text-xs focus:outline-none focus:ring-2 focus:ring-indigo-600 transition" />
        </div>
        {errPhone && <p className="text-[11px] text-rose-500 mt-0.5">{errPhone}</p>}
      </div>

      <div className="grid grid-cols-2 gap-2">
        <div>
          <label className="block text-[11px] font-bold text-slate-700 uppercase mb-1">Giới tính</label>
          <select value={gender} onChange={(e) => { setGender(e.target.value); setErrGender(""); }} className="w-full px-3 py-2 bg-slate-50 border border-slate-200 rounded-xl text-xs focus:outline-none focus:ring-2 focus:ring-indigo-600 transition text-slate-700">
            <option value="">Chọn giới tính</option>
            <option value="MALE">Nam</option>
            <option value="FEMALE">Nữ</option>
            <option value="OTHER">Khác</option>
          </select>
          {errGender && <p className="text-[11px] text-rose-500 mt-0.5">{errGender}</p>}
        </div>

        <div>
          <label className="block text-[11px] font-bold text-slate-700 uppercase mb-1">Ngày sinh</label>
          <input 
            type="date" 
            value={dateOfBirth} 
            max={new Date().toISOString().split("T")[0]}
            onChange={(e) => { setDateOfBirth(e.target.value); setErrDateOfBirth(""); }} 
            className="w-full px-3 py-2 bg-slate-50 border border-slate-200 rounded-xl text-xs focus:outline-none focus:ring-2 focus:ring-indigo-600 transition text-slate-700" 
          />
          {errDateOfBirth && <p className="text-[11px] text-rose-500 mt-0.5">{errDateOfBirth}</p>}
        </div>
      </div>

      <div className="pt-1">
        <div className="flex items-center space-x-2 cursor-pointer" onClick={() => { setChecked(!checked); setErrChecked(""); }}>
          {checked ? <CheckSquare className="w-4 h-4 text-indigo-600 shrink-0" /> : <Square className="w-4 h-4 text-slate-400 shrink-0" />}
          <span className="text-[11px] text-slate-600">Tôi đồng ý với các <span className="text-indigo-600 font-semibold underline">Điều khoản dịch vụ</span></span>
        </div>
        {errChecked && <p className="text-[11px] text-rose-500 mt-0.5">{errChecked}</p>}
      </div>

      <button type="submit" disabled={loading} className="w-full py-2.5 bg-indigo-600 hover:bg-indigo-500 text-white font-bold rounded-xl shadow-lg shadow-indigo-600/30 transition flex items-center justify-center space-x-2 text-xs mt-2">
        {loading ? <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span> : <span>Đăng Ký Tài Khoản</span>}
      </button>
    </form>
  );
}